import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  activeModal: string | null;
}

interface UIActions {
  toggleSidebar: () => void;
  setSidebarCollapsed: (value: boolean) => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIState & UIActions>()(
  devtools(
    set => ({
      sidebarCollapsed: false,
      activeModal: null,

      toggleSidebar: () =>
        set(state => ({ sidebarCollapsed: !state.sidebarCollapsed }), false, 'ui/toggleSidebar'),

      setSidebarCollapsed: value =>
        set({ sidebarCollapsed: value }, false, 'ui/setSidebarCollapsed'),

      openModal: modalId => set({ activeModal: modalId }, false, 'ui/openModal'),

      closeModal: () => set({ activeModal: null }, false, 'ui/closeModal'),
    }),
    { name: 'UIStore', enabled: import.meta.env.DEV }
  )
);
